import { UnitNormalizationManager } from "@/components/UnitNormalizationManager";

const UnitNormalizationPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <UnitNormalizationManager />
      </div>
    </div>
  );
};

export default UnitNormalizationPage;